/* Product recommendation quick add; delegated because Shopify loads recommendations asynchronously. */
(() => {
  if (window.__hbcaRelatedPlusInstalled) return;
  window.__hbcaRelatedPlusInstalled = true;
  document.addEventListener('click', async (event) => {
    const section = event.target.closest('product-recommendations');
    if (!section) return;
    const card = event.target.closest('.card-wrapper');
    if (!card) return;
    const button = card.querySelector('.card__inner > .bp-plus-add[data-variant-id]');
    if (!button) return;
    const rect = button.getBoundingClientRect();
    const hit = button.contains(event.target) || (event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom);
    if (!hit) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (button.disabled || button.dataset.hbcaBusy === '1') return;
    button.dataset.hbcaBusy = '1';
    button.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(root + 'cart/add.js', {
        method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Unable to add item');
      document.dispatchEvent(new CustomEvent('hbca:cart:updated',{detail:data}));
      if (window.HBCAFlyoutCart) {
        if (typeof window.HBCAFlyoutCart.refresh === 'function') await window.HBCAFlyoutCart.refresh();
        if (typeof window.HBCAFlyoutCart.open === 'function') await window.HBCAFlyoutCart.open();
      } else {
        console.warn('[HBCA] Added item; HBCAFlyoutCart.open is unavailable.');
      }
    } catch(error) { console.error('[HBCA] Related quick add failed:',error); alert(error.message || 'Unable to add this product.'); }
    finally { delete button.dataset.hbcaBusy; button.removeAttribute('aria-busy'); }
  }, true);
})();
